function anabolicPage(programs, goals) {
    return {
      // State
      isScrolled: false,
      isMobileMenuOpen: false,
      cartCount: 0,
      testimonialSlide: 0,
      filters: {
        goal: "",
        level: "",
        length: "",
        equipment: "",
        nutrition: "",
        price: "",
      },
      sort: "Featured",
      
      programs: programs || [],
      goalTabs: goals ? goals.map(g => g.trim()).filter(Boolean) : [],
      
      testimonials: [
          { rating: 5, title: "Constant Progress", content: "4 weeks into the program now and I am seeing consistent progress. The structure is perfect for natural lifters.", author: "Kyle Toner", plan: "Anabolic Fat Loss Meal Plan", verified: true },
          { rating: 5, title: "Fat Loss Program is Great", content: "Fat loss program helped me drop 4.5kg in 2 weeks. Great meals & easy to follow. Best investment I've made.", author: "Silas Vincent", plan: "Anabolic Fat Loss Meal Plan", verified: true },
          { rating: 5, title: "Worth The Hype", content: "30 days in and can confidently say that this meal plan does exactly what it says. No BS, just results.", author: "Harry", plan: "Anabolic Fat Loss Meal Plan", verified: true },
      ],

      // Computed
      get sortedPrograms() {
        const filtered = this.programs.filter(p => {
          const goal = !this.filters.goal || p.goal === this.filters.goal;
          const level = !this.filters.level || (this.filters.level === "All levels" ? true : p.level === this.filters.level);
          const length = !this.filters.length || p.length === this.filters.length;
          const equipment = !this.filters.equipment || p.equipment === this.filters.equipment;
          const nutrition = !this.filters.nutrition || p.nutrition === this.filters.nutrition;
          const price = !this.filters.price ||
            (this.filters.price === "Under $50" && p.price < 50) ||
            (this.filters.price === "$50 – $75" && p.price >= 50 && p.price <= 75) ||
            (this.filters.price === "Over $75" && p.price > 75);
          return goal && level && length && equipment && nutrition && price;
        });

        if (this.sort === 'Featured') {
          return filtered;
        }
        
        const sorted = [...filtered].sort((a, b) => {
          switch (this.sort) {
            case "Price (Low→High)": return a.price - b.price;
            case "Price (High→Low)": return b.price - a.price;
            case "A-Z": return a.title.localeCompare(b.title);
            case "Z-A": return b.title.localeCompare(a.title);
            case "Newest": return b.id - a.id;
            case "Oldest": return a.id - b.id;
            default: return 0;
          }
        });
        return sorted;
      },

      // Methods
      handleScroll() {
        this.isScrolled = window.scrollY > 50;
      },
      resetFilters() {
          this.filters = { goal: "", level: "", length: "", equipment: "", nutrition: "", price: "" };
      },
      init() {
          // Testimonial carousel auto-play
          setInterval(() => {
              this.testimonialSlide = (this.testimonialSlide + 1) % this.testimonials.length;
          }, 6000);
      }
    }
} 